var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarResetarSenha()}}},[_c('i',{staticClass:"fa fa-key"}),_vm._v(" Resetar Senha ")])
}
var staticRenderFns = []

export { render, staticRenderFns }